import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import actions from "../../actions";
import {
  TextField,
  Button,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Container,
  TablePagination,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import {
  getAllPermission,
  createRole,
  getAllRole,
  updateRole,
  deleteAdminUser,
} from "../../apis";
import "./customButton.css";
import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";

const CreateRole = ({ stopLoadingRequest }) => {
  const [roleName, setRoleName] = useState("");
  const [permissions, setPermissions] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [selectedUMPermissions, setSelectedUMPermissions] = useState([]);
  const [roles, setRoles] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [editingRoleId, setEditingRoleId] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [roleToDelete, setRoleToDelete] = useState(null);

  const [errors, setErrors] = useState({
    roleName: "",
    permissions: "",
    umPermission:""
  });

  const fetchPermissions = useCallback(async () => {
    try {
      const response = await getAllPermission();
      setPermissions(response.data.data);
    } catch (error) {
      console.error("Failed to fetch permissions:", error);
    }
  }, []);

  const fetchRoles = useCallback(async () => {
    try {
      const response = await getAllRole();
      setRoles(response?.data?.data);
    } catch (error) {
      console.error("Failed to fetch roles:", error);
    }
  }, []);

  useEffect(() => {
    fetchPermissions();
    fetchRoles();
    stopLoadingRequest();
  }, [fetchPermissions, fetchRoles, stopLoadingRequest]);

  const handleCreateRole = async (event) => {
    event.preventDefault();
    let tempErrors = {};

    if (!roleName) {
      tempErrors["roleName"] = "Role name is required";
    }
    if (!selectedPermissions.length) {
      tempErrors["permissions"] = "At least one permission is required";
    }
    if(selectedPermissions.length > 0&& selectedPermissions.includes("66b20db664b1e06821e91195") && !selectedUMPermissions.length){
      tempErrors["umPermission"] = "At least one user management permission is required";
    }
    if (Object.keys(tempErrors)?.length > 0) {
      setErrors(tempErrors);
      stopLoadingRequest();
      return;
    } else {
      setErrors({});
    }

    try {
      if (editingRoleId) {
        await updateRole({
          name: roleName,
          permissions: selectedPermissions,
          roleId: editingRoleId,
          userManagementPermissions: selectedUMPermissions
        });
        toast.success("Role Updated Successfully");
      } else {
        console.log("selectedUMPermissions",selectedUMPermissions)

        await createRole({ name: roleName, permissions: selectedPermissions, userManagementPermissions: selectedUMPermissions });
        toast.success("Role Created Successfully");
      }
      setRoleName("");
      setSelectedPermissions([]);
      setSelectedUMPermissions([]);
      setEditingRoleId(null);
      fetchRoles();
    } catch (error) {
      console.error("Failed to save role:", error);
      toast.error("Failed to save role");
    }
  };

  const handleEditRole = (role) => {
    setRoleName(role.name);
    setSelectedPermissions(
      role.permissions.map((permission) => permission._id)
    );
    setSelectedUMPermissions(role.userManagementPermissions.map((permission) => permission))
    window.scrollTo(0,0)
    setEditingRoleId(role._id);
  };

  const handleDeleteRole = async () => {
    try {
      if (roleToDelete) {
        await deleteAdminUser({ roleId: roleToDelete._id });
        toast.success("Role Deleted Successfully");
        fetchRoles();
      }
    } catch (error) {
      console.error("Failed to delete role:", error);
      toast.error("Failed to delete role");
    } finally {
      setConfirmDialogOpen(false);
      setRoleToDelete(null);
    }
  };

  const openConfirmDialog = (role) => {
    setRoleToDelete(role);
    setConfirmDialogOpen(true);
  };

  const handleCloseConfirmDialog = () => {
    setConfirmDialogOpen(false);
    setRoleToDelete(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleDeselect = async (event, permission, role) => {
    event.stopPropagation();

    // Filter the permissions for the selected role
    const updatedPermissions = role.permissions
      .filter((perm) => perm._id !== permission._id)
      .map((perm) => perm._id); // Get only the permission IDs

    try {
      // Call updateRole with the filtered permission IDs
      await updateRole({
        name: role.name, // Keep the existing name
        permissions: updatedPermissions, // Pass the updated permission IDs
        roleId: role._id, // Use the role's ID directly
      });

      // Update the roles in the local state after successful update
      setRoles((prevRoles) =>
        prevRoles.map((r) =>
          r._id === role._id ? { ...r, permissions: updatedPermissions } : r
        )
      );

      toast.success("Role Updated Successfully");
      await fetchRoles();
    } catch (error) {
      toast.error("Failed to update role");
    }
  };

  const capitalizeName = (name) => {
    return name
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };
  
  const userManagementPermission = [{id:"bulkUpload",name:"Bulk Upload"},{id:"category",name:"Category"},{id:"subCategory",name:"Subcategory"},{id:"moodboard",name:"Moodboard"},{id:"stylistChatHistory",name:"Stylist Chat History"},{id:"aiChat",name:"AI Chat"},{id:"supportChat",name:"Support Chat"},{id:"permissionHistory",name:"Permission History"},{id:"userStats",name:"User Stats"}]

  return (
    <div style={{ display: "flex", marginTop: "5rem" }}>
      <Container maxWidth="lg" className="create-role-container">
        <Box
          sx={{
            borderRadius: "8px",
            boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#ffffff",
            padding: "20px",
            backgroundColor: "#FAF9F6",
          }}
        >
          <Typography variant="h5" component="h1" gutterBottom>
            {editingRoleId ? "Edit Role" : "Create Role"}
          </Typography>
          <Box
            component="form"
            onSubmit={handleCreateRole}
            display="flex"
            flexDirection="column"
            gap={3}
            mb={4}
          >
            <Box>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                Role Name
              </label>
              <div className="input-wrapper">
                <TextField
                  margin="none"
                  variant="outlined"
                  value={roleName}
                  onChange={(e) => {
                    setErrors((prev) => ({ ...prev, roleName: "" }));
                    setRoleName(e.target.value);
                  }}
                  size="medium"
                  fullWidth
                  sx={{ fontSize: "0.875rem" }}
                  inputProps={{
                    style: { padding: "10px 12px" ,border:"none"},
                  }}
                />
                {errors.roleName && <p>{errors.roleName}</p>}
              </div>
            </Box>
            <Box>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                Permissions
              </label>
              <div className="input-wrapper">
                <Select
                  sx={{
                    maxHeight: "200px", // Limit the height of the dropdown to 200px
                    overflowY: "auto", // Enable vertical scrolling when the list exceeds max height
                    width: "100%", // Ensure the select box takes full width
                    whiteSpace: "normal", // Allow the text to wrap if needed
                  }}
                  variant="outlined"
                  fullWidth
                  multiple
                  value={selectedPermissions}
                  // onChange={(e) => setSelectedPermissions(e.target.value)}
                  onChange={(e) => {
                    setSelectedPermissions(e.target.value);
                    if (e.target.value.length > 0) {
                      setErrors((prev) => ({
                        ...prev,
                        permissions: "",
                      }));
                    }
                  }}
                  renderValue={(selected) =>
                    selected
                      .map(
                        (permId) =>
                          permissions.find(
                            (permission) => permission._id === permId
                          )?.name
                      )
                      .join(", ")
                  }
                  size="medium"
                  // sx={{ fontSize: "0.875rem" }}
                >
                  {permissions.map((permission) => (
                    <MenuItem key={permission._id} value={permission._id}>
                     {capitalizeName(permission.name || '')}
                    </MenuItem>
                  ))}
                </Select>
                {errors.permissions && <p>{errors.permissions}</p>}
              </div>
            </Box>
           {(selectedPermissions.length > 0&&selectedPermissions.includes("66b20db664b1e06821e91195")) && <Box>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
               User Management Permissions
              </label>
              <div className="input-wrapper">
                <Select
                  sx={{
                    maxHeight: "200px", // Limit the height of the dropdown to 200px
                    overflowY: "auto", // Enable vertical scrolling when the list exceeds max height
                    width: "100%", // Ensure the select box takes full width
                    whiteSpace: "normal", // Allow the text to wrap if needed
                  }}
                  variant="outlined"
                  fullWidth
                  multiple
                  value={selectedUMPermissions}
                  // onChange={(e) => setSelectedPermissions(e.target.value)}
                  onChange={(e) => {
                    setSelectedUMPermissions(e.target.value);
                    if (e.target.value.length > 0) {
                      setErrors((prev) => ({
                        ...prev,
                        umPermissions: "",
                      }));
                    }
                  }}
                  renderValue={(selected) =>
                    selected
                      .map(
                        (permId) =>
                          userManagementPermission.find(
                            (permission) => permission.id === permId
                          )?.name
                      )
                      .join(", ")
                  }
                  size="medium"
                  // sx={{ fontSize: "0.875rem" }}
                >
                  {userManagementPermission.map((permission) => (
                    <MenuItem key={permission.id} value={permission.id}>
                     {capitalizeName(permission.name || '')}
                    </MenuItem>
                  ))}
                </Select>
                {errors.umPermission && <p>{errors.umPermission}</p>}
              </div>
            </Box>}
            <button className="custom-button" type="submit" style={{border:"1px solid black"}}>
              {editingRoleId ? "Update Role" : "Create Role"}
            </button>
          </Box>
          <TableContainer
            component={Paper}
            className="custom-table-container "
            sx={{ backgroundColor: "#FAF9F6" }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontSize: "0.875rem" }}>Role</TableCell>
                  <TableCell sx={{ fontSize: "0.875rem" }}>
                    Permissions
                  </TableCell>
                  <TableCell sx={{ fontSize: "0.875rem" }}>
                    User Management Permissions
                  </TableCell>
                  <TableCell sx={{ fontSize: "0.875rem" }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(roles) && roles.length > 0 ? (
                  roles
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((role, index) => (
                      <TableRow key={index}>
                        <TableCell sx={{ fontSize: "0.875rem" }}>
                          {role.name}
                        </TableCell>
                        <TableCell sx={{ fontSize: "0.875rem" }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "8px",
                            }}
                          >
                            {role?.permissions &&
                              role?.permissions.map((permission) => (
                                <Box
                                  key={permission._id}
                                  sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      backgroundColor: "#e0e0e0",
                                      padding: "4px 8px",
                                      borderRadius: "16px",
                                      display: "inline-block",
                                    }}
                                  >
                                    {capitalizeName(permission?.name)}
                                    {/* <span
                                      onClick={(event) => {
                                        handleDeselect(event, permission, role);
                                      }}
                                      style={{
                                        marginLeft: "8px",
                                        cursor: "pointer",
                                        color: "grey",
                                      }}
                                    >
                                      x 
                                    </span> */}
                                  </span>
                                </Box>
                              ))}
                          </Box>
                        </TableCell>
                        <TableCell sx={{ fontSize: "0.875rem" }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "8px",
                            }}
                          >
                            {role?.userManagementPermissions &&
                              role?.userManagementPermissions.map((permission,idx) => (
                                <Box
                                  key={idx}
                                  sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      backgroundColor: "#e0e0e0",
                                      padding: "4px 8px",
                                      borderRadius: "16px",
                                      display: "inline-block",
                                    }}
                                  >
                                    { userManagementPermission.find(
                            (p) => p.id === permission
                          )?.name}
                                  </span>
                                </Box>
                              ))}
                          </Box>
                        </TableCell>
                        {role?.canEdit && 
                        <TableCell>
                          <IconButton
                            aria-label="edit"
                            onClick={() => handleEditRole(role)}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            aria-label="delete"
                            onClick={() => openConfirmDialog(role)}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </TableCell> 
                        }
                        
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No roles available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={roles.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </Box>
      </Container>

      {/* Confirmation Dialog */}
      <Dialog
        open={confirmDialogOpen}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            Are you sure you want to delete this role? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteRole} color="secondary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      stopLoadingRequest: actions.loader.stopLoading,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(CreateRole);
